module.exports = __webpack_public_path__ + "HarshalShinde-bd8007b3.webp";